// Asset cache utility for critical SVG logos
class AssetCache {
  constructor() {
    this.cache = new Map();
    this.preloadedAssets = [
      '/assets/flare-logo.svg',
      '/assets/songbird-logo.svg',
      '/assets/both-logo.svg'
    ];
    this.init();
  }

  init() {
    // Preload and cache assets on initialization
    this.preloadedAssets.forEach(src => {
      this.preloadAsset(src);
    });
  }

  preloadAsset(src) {
    if (this.cache.has(src)) {
      return Promise.resolve(this.cache.get(src));
    }

    return new Promise((resolve, reject) => {
      const img = new Image();
      
      img.onload = () => {
        this.cache.set(src, img);
        console.log(`✓ Cached asset: ${src}`);
        resolve(img);
      };
      
      img.onerror = () => {
        console.warn(`✗ Failed to cache asset: ${src}`);
        reject(new Error(`Failed to load ${src}`));
      };
      
      img.src = src;
    });
  }

  isAssetCached(src) {
    return this.cache.has(src);
  }

  getCachedAsset(src) {
    return this.cache.get(src);
  }

  // Force refresh a cached asset
  refreshAsset(src) {
    this.cache.delete(src);
    return this.preloadAsset(src);
  }
}

// Export singleton instance
export const assetCache = new AssetCache();
export default assetCache;
